module.exports = __webpack_public_path__ + "static/orderBox-5300ce280f3a362583a14dc69319eb39.png";